<template>
  <PageLayout
    :is-loading="isLoading"
    page-title="Tambah Points"
    :show-banner="false"
    :show-sponsors="false"
    :show-back-button="true"
    :hide-sidebar="true"
    @back="goBack"
  >

    <!-- Form Section -->
    <div class="form-section">
      <div class="form-container">
        <form @submit.prevent="submitData" class="reward-form">
          <div class="form-grid">
            <!-- Date Field -->
            <div class="form-group">
              <label class="form-label">Tanggal :</label>
              <div class="input-wrapper">
                <input
                  type="date"
                  v-model="forms.date"
                  class="form-input"
                  required
                  placeholder="dd/mm/yyyy"
                />
                <i class="mdi mdi-calendar input-icon"></i>
              </div>
            </div>

            <!-- Event Type Field -->
            <div class="form-group">
              <label class="form-label">Jenis Event :</label>
              <div class="select-wrapper">
                <select
                  v-model="modelEventType"
                  @change="callEvent()"
                  class="form-select"
                  required
                >
                  <option value="">Pilih Jenis Event</option>
                  <option v-for="item in eventType" :value="item.id" :key="item.id">
                    {{ item.type }}
                  </option>
                </select>
                <i class="mdi mdi-chevron-down select-icon"></i>
              </div>
            </div>

            <!-- Event Name Field -->
            <div class="form-group">
              <label class="form-label">Nama Event :</label>
              <div class="select-wrapper">
                <select
                  v-model="modelEvent"
                  class="form-select"
                  required
                  :disabled="!modelEventType"
                >
                  <option value="">Pilih Nama Event</option>
                  <option v-for="item in event" :value="item.id" :key="item.id">
                    {{ item.name }}
                  </option>
                </select>
                <i class="mdi mdi-chevron-down select-icon"></i>
              </div>
            </div>

            <!-- Username Field -->
            <div class="form-group">
              <label class="form-label">Username :</label>
              <div class="input-wrapper">
                <input
                  type="text"
                  v-model="forms.username"
                  class="form-input"
                  required
                  placeholder="Masukkan Username"
                />
                <i class="mdi mdi-account input-icon"></i>
              </div>
            </div>

            <!-- Community Field (for Bert Influencer) -->
            <div v-if="detailUser.community && detailUser.community.community === 'Bert Influencer'" class="form-group full-width">
              <label class="form-label">Community :</label>
              <div class="select-wrapper">
                <select
                  v-model="forms.community"
                  class="form-select"
                  required
                >
                  <option value="">Pilih Community</option>
                  <option value="Geng Glowing">Geng Glowing</option>
                  <option value="Ibu2Canggih">Ibu2Canggih</option>
                  <option value="Ikan Galau">Ikan Galau</option>
                </select>
                <i class="mdi mdi-chevron-down select-icon"></i>
              </div>
            </div>

            <!-- Link Posting Field -->
            <div class="form-group full-width">
              <label class="form-label">Link Postingan (Opsional) :</label>
              <div class="input-wrapper">
                <input
                  type="url"
                  v-model="forms.link_upload"
                  class="form-input"
                  placeholder="Masukkan Link Postingan"
                />
                <i class="mdi mdi-link input-icon"></i>
              </div>
            </div>

            <!-- File Upload Field -->
            <div class="form-group full-width">
              <label class="form-label">Upload Bukti Partisipan (Opsional) :</label>
              <div class="upload-wrapper">
                <div class="upload-area" @click="triggerFileInput" :class="{ 'has-file': file }">
                  <div v-if="!file" class="upload-placeholder">
                    <i class="mdi mdi-cloud-upload upload-icon"></i>
                    <p class="upload-text">Upload File</p>
                    <span class="upload-hint">Klik untuk memilih file</span>
                  </div>
                  <div v-else class="upload-success">
                    <i class="mdi mdi-file-check upload-icon success"></i>
                    <p class="upload-text">{{ file.name }}</p>
                    <span class="upload-hint">Klik untuk mengganti file</span>
                  </div>
                  <input
                    type="file"
                    ref="fileInput"
                    @change="handleFileChange"
                    accept="image/*"
                    class="file-input"
                  />
                </div>
              </div>
            </div>
          </div>

          <!-- Submit Button -->
          <div class="form-actions">
            <bert-button
              type="submit"
              variant="primary"
              size="lg"
              :loading="isLoading"
              :disabled="!isFormValid"
              full-width
              class="submit-btn"
            >
              Submit
            </bert-button>
          </div>
        </form>
      </div>
    </div>
  </PageLayout>
</template>

<script>
import AppPageLayout from '@/components/ui/PageLayout.vue';
import BertButton from '@/components/ui/Button.vue';

export default {
  name: "NewRewardAdd",
  components: {
    PageLayout: AppPageLayout,
    'bert-button': BertButton
  },
  data() {
    return {
      isLoading: false,
      detailUser: {},
      forms: {
        date: '',
        username: '',
        link_upload: '',
        community: ''
      },
      eventType: [],
      modelEventType: '',
      event: [],
      modelEvent: '',
      file: null,
      errors: []
    };
  },
  computed: {
    isFormValid() {
      return this.forms.date && 
             this.modelEventType && 
             this.modelEvent && 
             this.forms.username &&
             (!this.isBertInfluencer || this.forms.community);
    },
    isBertInfluencer() {
      return this.detailUser.community && 
             this.detailUser.community.community === 'Bert Influencer';
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    submitData() {
      if (!this.isFormValid) return;
      
      this.isLoading = true;
      let formData = new FormData();
      
      formData.append("date", this.forms.date);
      formData.append("username", this.forms.username);
      formData.append("link_upload", this.forms.link_upload || '');
      formData.append("id_event", this.modelEvent);
      
      if (this.isBertInfluencer) {
        formData.append("community", this.forms.community);
      }
      
      if (this.file) {
        formData.append("image", this.file);
      }

      const baseURI = this.$settings.endPoint + "event-form/create";
      this.$http
        .post(baseURI, formData, { 
          timeout: 10000,
          headers: {
            'AppToken': this.$settings.jwtSecret,
          }
        })
        .then((response) => {
          this.isLoading = false;
          if (response.data.status === 200) {
            this.success('Berhasil menambahkan poin!');
            this.resetForm();
            // Redirect back to points page after success
            setTimeout(() => {
              this.$router.push('/user/points');
            }, 1500);
          } else {
            this.handleErrors(response.data.errors);
          }
        })
        .catch(error => {
          this.isLoading = false;
          this.handleError(error);
        });
    },

    callEvent() {
      if (!this.modelEventType || !this.forms.date) return;
      
      const baseURI = this.$settings.endPoint + "master-event" + 
                     "?id_type=" + this.modelEventType + 
                     "&source=user&date=" + this.forms.date;
      
      this.$http
        .get(baseURI, { 
          timeout: 10000,
          headers: {
            'AppToken': this.$settings.jwtSecret,
          }
        })
        .then((response) => {
          this.event = response.data.datas.data || [];
          this.modelEvent = ''; // Reset event selection
        })
        .catch(error => {
          this.handleError(error);
        });
    },

    loadEventType() {
      const baseURI = this.$settings.endPoint + "event-type?source=user";
      this.isLoading = true;
      
      this.$http
        .get(baseURI, { 
          timeout: 10000,
          headers: {
            'AppToken': this.$settings.jwtSecret,
          }
        })
        .then((response) => {
          this.isLoading = false;
          this.eventType = response.data.datas.data || [];
        })
        .catch(error => {
          this.isLoading = false;
          this.handleError(error);
        });
    },

    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        // Validate file type
        if (!file.type.startsWith('image/')) {
          this.error('Please select an image file');
          return;
        }
        
        // Validate file size (max 5MB)
        if (file.size > 5 * 1024 * 1024) {
          this.error('File size must be less than 5MB');
          return;
        }
        
        this.file = file;
      }
    },

    triggerFileInput() {
      this.$refs.fileInput.click();
    },

    resetForm() {
      this.forms = {
        date: '',
        username: '',
        link_upload: '',
        community: ''
      };
      this.modelEventType = '';
      this.modelEvent = '';
      this.event = [];
      this.file = null;
      this.errors = [];
    },

    fetchUserData() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub || {};
    },

    handleErrors(errors) {
      this.errors = errors;
      if (errors) {
        Object.keys(errors).forEach(key => {
          if (errors[key] && errors[key].length > 0) {
            this.error(errors[key][0]);
          }
        });
      }
    },

    handleError(error) {
      if (error.response) {
        if (error.response.status === 422) {
          this.handleErrors(error.response.data.errors);
        } else if (error.response.status === 500) {
          this.$router.push('/server-error');
        } else if (error.response.status === 401) {
          this.$router.push("/authorized-error");
        } else {
          this.$router.push('/page-not-found');
        }
      } else if (error.code === "ECONNABORTED") {
        this.error("Please check your internet connection");
      } else {
        this.error("An error occurred. Please try again.");
      }
    },

    success(message) {
      this.$swal({
        title: 'Berhasil!',
        text: message,
        icon: 'success',
        confirmButtonText: 'OK',
        confirmButtonColor: '#F2994A'
      });
    },

    error(message) {
      this.$swal({
        title: 'Error!',
        text: message,
        icon: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: '#F2994A'
      });
    }
  },

  watch: {
    'forms.date'() {
      // Reset event selection when date changes
      this.modelEvent = '';
      this.event = [];
      if (this.modelEventType) {
        this.callEvent();
      }
    }
  },

  mounted() {
    this.fetchUserData();
    this.loadEventType();
  }
};
</script>

<style scoped>
/* ========================================= */
/* HEADER SECTION                            */
/* ========================================= */
.reward-add-header {
  background: linear-gradient(135deg, #F2994A 0%, #F2C94C 100%);
  padding: 32px;
  margin: 0 auto 32px auto;
  border-radius: 16px;
  max-width: 1200px;
  width: calc(100% - 64px);
  position: relative;
  overflow: hidden;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  z-index: 2;
}

.header-icon {
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.5rem;
}

.header-title {
  color: white;
  font-size: 1.8rem;
  font-weight: 700;
  margin: 0;
  text-align: center;
  flex: 1;
}

.header-logo {
  width: 48px;
  height: 48px;
  background: white;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
}

.logo-icon {
  width: 32px;
  height: 32px;
}

/* ========================================= */
/* FORM SECTION                              */
/* ========================================= */
.form-section {
  padding: 0 32px;
  margin: 0 auto 32px auto;
  max-width: 1200px;
  width: calc(100% - 64px);
}

.form-container {
  background: white;
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.reward-form {
  width: 100%;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  margin-bottom: 32px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

.form-label {
  font-size: 0.9rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
}

/* Input Styles */
.input-wrapper {
  position: relative;
}

.form-input {
  width: 100%;
  padding: 12px 16px 12px 44px;
  border: 2px solid #E5E7EB;
  border-radius: 8px;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  background: #F9FAFB;
}

.form-input:focus {
  outline: none;
  border-color: #F2994A;
  background: white;
  box-shadow: 0 0 0 3px rgba(242, 153, 74, 0.1);
}

.input-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #9CA3AF;
  font-size: 1.1rem;
}

/* Select Styles */
.select-wrapper {
  position: relative;
}

.form-select {
  width: 100%;
  padding: 12px 44px 12px 16px;
  border: 2px solid #E5E7EB;
  border-radius: 8px;
  font-size: 0.9rem;
  background: #F9FAFB;
  cursor: pointer;
  transition: all 0.3s ease;
  appearance: none;
}

.form-select:focus {
  outline: none;
  border-color: #F2994A;
  background: white;
  box-shadow: 0 0 0 3px rgba(242, 153, 74, 0.1);
}

.form-select:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.select-icon {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #9CA3AF;
  font-size: 1.1rem;
  pointer-events: none;
}

/* Upload Styles */
.upload-wrapper {
  width: 100%;
}

.upload-area {
  border: 2px dashed #D1D5DB;
  border-radius: 12px;
  padding: 32px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #F9FAFB;
}

.upload-area:hover {
  border-color: #F2994A;
  background: #FEF3E2;
}

.upload-area.has-file {
  border-color: #10B981;
  background: #ECFDF5;
}

.upload-placeholder,
.upload-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.upload-icon {
  font-size: 2.5rem;
  color: #9CA3AF;
}

.upload-icon.success {
  color: #10B981;
}

.upload-text {
  font-size: 1rem;
  font-weight: 600;
  color: #374151;
  margin: 0;
}

.upload-hint {
  font-size: 0.85rem;
  color: #6B7280;
}

.file-input {
  display: none;
}

/* Form Actions */
.form-actions {
  display: flex;
  justify-content: center;
  padding-top: 24px;
  border-top: 1px solid #E5E7EB;
}

.submit-btn {
  min-width: 200px;
}

/* ========================================= */
/* MOBILE RESPONSIVE STYLES                  */
/* ========================================= */
@media (max-width: 768px) {
  .reward-add-header,
  .form-section {
    width: calc(100% - 40px);
    margin: 0 20px 24px 20px;
    padding: 20px;
  }
  
  .form-container {
    padding: 24px 20px;
  }
  
  .header-content {
    gap: 16px;
  }
  
  .header-title {
    font-size: 1.4rem;
  }
  
  .header-icon,
  .header-logo {
    width: 40px;
    height: 40px;
  }
  
  .logo-icon {
    width: 24px;
    height: 24px;
  }
  
  .form-grid {
    grid-template-columns: 1fr;
    gap: 20px;
    margin-bottom: 24px;
  }
  
  .form-group.full-width {
    grid-column: 1;
  }
  
  .upload-area {
    padding: 24px 16px;
  }
  
  .upload-icon {
    font-size: 2rem;
  }
  
  .submit-btn {
    min-width: 100%;
  }
}

</style>